import { RuntimeExamSessionScreen } from '@/features/unified-learning/runtime/screens/RuntimeExamSessionScreen';

export default function LearnExamSessionRoute() {
  return <RuntimeExamSessionScreen />;
}
